import { createRouter, createWebHistory } from 'vue-router'

import DefaultLayout from '@/layouts/DefaultLayout'
import store from '../store'
// registration routes
import RegisterStep1 from '@/views/registration/RegisterStep1.vue'
import RegisterStep2 from '@/views/registration/RegisterStep2.vue'

const routes = [
  // Registration routes
  {
    path: '/signup',
    name: 'Registration - Fundraiser Details',
    component: RegisterStep1,
    meta: { guest: true },
  },
  {
    path: '/signup/step-2',
    name: 'Registration - Personal Details',
    component: RegisterStep2,
    meta: { guest: true },
  },
  // End Registration routes

  {
    path: '/',
    name: 'Fundraiser login',
    component: () => import('../views/auth/LoginView.vue'),
    redirect: '/login',
    meta: { guest: true },
    children: [
      {
        path: '/login',
        name: 'Fundraiser login',
        component: () => import('@/views/auth/LoginView.vue'),
      },
    ],
  },

  {
    path: '/forgot-password',
    name: 'Forgot Password',
    component: () => import('@/views/auth/ForgotPasswordView.vue'),
    meta: { guest: true },
  },
  {
    path: '/new-password/:passKey',
    name: 'New Password',
    component: () => import('@/views/auth/ResetPasswordView.vue'),
    meta: { guest: true },
  },
  {
    path: '/statement/:campaignID/:statementKey',
    name: 'Fundraiser Statement',
    component: () => import('@/views/statement/accountStatement.vue'),
  },
  {
    path: '/verify-patron/:campaignID/:patronKey',
    name: 'Verify Patron',
    component: () => import('@/views/details/verifyPatron'),
  },
  {
    path: '/changa-referral/:refCode',
    name: 'referral link',
    component: () => import('@/views/referRedirect'),
  },
  {
    path: '/account',
    name: 'Account',
    component: DefaultLayout,
    redirect: '/account',
    meta: { requiresAuth: true },
    children: [
      {
        path: '/new-fundraiser',
        name: 'New Fundraiser',
        component: () => import('@/views/users/newFundraiser.vue'),
      },
      {
        path: '/account',
        name: 'Account',
        component: () =>
          import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard.vue'),
      },
      {
        path: '/summary',
        name: 'Summary',
        component: () =>
          import(/* webpackChunkName: "summary" */ '@/views/Summary.vue'),
      },
      {
        path: '/donations',
        name: 'Donations',
        component: () => import('@/views/donations/AccountStatement.vue'),
      },
      {
        path: '/withdraw',
        name: 'Withdraw',
        component: () => import('@/views/withdrawal/Withdrawals.vue'),
      },
      {
        path: '/documents',
        name: 'Documents',
        component: () => import('@/views/verifications/Documents.vue'),
      },
      {
        path: '/treasurers',
        name: 'Custodians',
        component: () => import('@/views/verifications/Custodians.vue'),
      },
      {
        path: '/fundraiser-details',
        name: 'Fundraiser Details',
        component: () => import('@/views/details/FundDetails.vue'),
      },
      {
        path: '/story',
        name: 'Fundraiser Story',
        component: () => import('@/views/details/Story.vue'),
      },
      {
        path: '/images',
        name: 'Fundraiser Images',
        component: () => import('@/views/details/Images.vue'),
      },
      {
        path: '/video',
        name: 'Fundraiser Video',
        component: () => import('@/views/details/Video.vue'),
      },
      {
        /* deprecate this for now */
        path: '/patronss',
        name: 'Patrons',
        component: () => import('@/views/details/Patrons.vue'),
      },
      {
        path: '/feedback',
        name: 'Feedback',
        component: () => import('@/views/utilities/Feedback.vue'),
      },
      {
        path: '/share',
        name: 'Share',
        component: () => import('@/views/utilities/Share.vue'),
      },
      {
        path: '/referral',
        name: 'Referral',
        component: () => import('@/views/utilities/Referral.vue'),
      },
      {
        path: '/update-donors',
        name: 'Update Donors',
        component: () => import('@/views/utilities/DonorUpdate.vue'),
      },
      {
        path: '/mchanga-affiliates',
        name: 'M-Changa Affiliates',
        beforeEnter() {
          window.location.href = 'https://www.mchanga.africa/affiliates'
        },
      },
      {
        path: '/logout',
        name: 'Logout',
        component: () => import('@/components/user/Logout.vue'),
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const token = localStorage.getItem('authToken')

    if (store.getters.isAuthenticated) {
      if (!token && to.path !== '/logout') {
        window.location.replace('/logout')
        return
      }
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.guest)) {
    if (store.getters.isAuthenticated) {
      next('/logout')
      return
    }
    next()
  } else {
    next()
  }
})

export default router
